export default __webpack_public_path__ + "static/media/icon_contact_1.b04d7c63.svg";